import { SharedModule } from './../../../shared/shared.module';
import { DoctorRoutingModule } from './doctor-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ListDoctorsComponent } from './../components/list-doctors/list-doctors.component';
import { DoctorComponent } from './doctor.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';

const components = [DoctorComponent, ListDoctorsComponent];

@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    DoctorRoutingModule,
    MatMenuModule,
    MatIconModule
  ],
  declarations: [...components]
})
export class DoctorModule {}
